import styles from "./Background.module.css";

import background from "../../../media/Activities/activitiesBanner.JPG";

const BackgroundActivities = () => {
    return(
        <article
        className={styles.article}
        style={{ backgroundImage:  `url(${background})` }}>
            <h1 className={styles.header}>Our Pillars</h1>
            <h4 className={styles.headersmtxt}>Service | Brotherhood | Profession</h4>
        </article>
    );
};

export default BackgroundActivities;